export * from './MicrosoftLogo'
